import { isNativeApp } from 'utils/platformHelpers';
import { isMobileDevice } from 'utils/pwaHelpers';

/**
 * Phones and tablets use Enter as return (a new line). The send button submits.
 * Desktop keyboards submit on Enter and insert a new line on Shift+Enter.
 * @returns {boolean}
 */
export const composerNewlineOnEnter = () => {
  if (typeof window === 'undefined') return false;
  if (isNativeApp()) return true;
  if (typeof navigator !== 'undefined' && isMobileDevice()) return true;
  if (typeof window.matchMedia === 'function') {
    return window.matchMedia('(pointer: coarse)').matches;
  }
  return false;
};

const isImeComposing = (event) =>
  Boolean(
    event.isComposing
    || event.nativeEvent?.isComposing
    || event.keyCode === 229
    || event.nativeEvent?.keyCode === 229,
  );

/**
 * Desktop: unmodified Enter sends. Shift+Enter (and other modifiers) inserts a newline.
 * Mobile: Enter inserts a newline and does not send.
 *
 * @param {KeyboardEvent} event
 * @param {{ newlineOnEnter?: boolean, canSend?: boolean, onSend?: () => void }} options
 */
export const handleComposerEnterKey = (
  event,
  { newlineOnEnter = false, canSend = false, onSend } = {},
) => {
  if (event.key !== 'Enter') return;
  if (isImeComposing(event)) return;

  const modified = event.shiftKey || event.altKey || event.ctrlKey || event.metaKey;
  if (modified || newlineOnEnter) return;

  event.preventDefault();
  if (event.repeat || !canSend) return;
  onSend?.();
};
